import { z } from 'zod';
/**
 * Base schema for custom field tags
 */
export const baseCustomFieldTagSchema = z.object({
    name: z
        .string()
        .min(1, 'Tag name is required')
        .max(50, 'Tag name must be less than 50 characters')
        .regex(/^[a-zA-Z0-9\s\-_]+$/, 'Tag name can only contain letters, numbers, spaces, hyphens, and underscores'),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Color must be a valid hex color')
        .nullish(),
    governmentId: z.number(),
});
/**
 * Create validation and DTO type
 */
export const customFieldTagCreateSchema = baseCustomFieldTagSchema.omit({ governmentId: true });
/**
 * Update validation and DTO type
 */
export const customFieldTagUpdateSchema = baseCustomFieldTagSchema
    .omit({ governmentId: true })
    .partial();
